<div [@dialog] *ngIf="visible" class="dialog">
  <h2>Add Item</h2>
  <div class="inner">
    <div class="form_wrapper">
      <p *ngIf="!fields || !fields.length">No fields defined.</p>
      <form *ngIf="fields && fields.length" class="pure-form pure-form-aligned" [formGroup]="myForm" (ngSubmit)="submit($event);">
        <fieldset>
          <field-input [field]="field" [form]="myForm" [requestHeaders]="requestHeaders"
                       [workingRowData]="workingRowData" [methodDataPath]="methodData.dataPath"
                       *ngFor="let field of fields"
                       class="pure-control-group">
          </field-input>
          <div class="center">
            <button type="submit" class="pure-button pure-button-primary button-large" [disabled]="myForm.invalid">Submit</button>
          </div>
          <app-loader [size]="'small'" [loading]="loading"></app-loader>
        </fieldset>
      </form>
    </div>
    <button *ngIf="closable" (click)="close()" aria-label="Close" class="dialog__close-btn"><i class="fa fa-times"></i></button>
  </div>
</div>

<div *ngIf="visible" class="overlay" (click)="close()"></div>
